import cn from '@/utils/cn';

interface Props {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  label: string;
  className?: string;
}

const SectionHeader = ({ icon: Icon, label, className }: Props) => (
  <div className={cn('flex items-center gap-2', className)}>
    <Icon width={18} className="shrink-0 text-primary" />
    <h5 className="h5 text-oxford-blue-500">{label}</h5>
  </div>
);

export default SectionHeader;
